/**
 * Test ID utilities for Select component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Select trigger
 * @param identifier - Select identifier
 * @returns Test ID string
 */
export const setSelectTriggerTestId = (identifier: string): string =>
  generateTestId("SelectTrigger", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Select content
 * @param identifier - Select identifier
 * @returns Test ID string
 */
export const setSelectContentTestId = (identifier: string): string =>
  generateTestId("SelectContent", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Select item
 * @param value - Item value
 * @returns Test ID string
 */
export const setSelectItemTestId = (value: string): string => generateTestId("SelectItem", value.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Select label
 * @param identifier - Label identifier
 * @returns Test ID string
 */
export const setSelectLabelTestId = (identifier: string): string =>
  generateTestId("SelectLabel", identifier.replace(/\s+/g, "-").toLowerCase());
